import { EntityPreviewContainerProps } from '@work4all/components/lib/components/entity-preview/types';

import { LookUp } from '@work4all/models/lib/Classes/LookUp.entity';
import { EMode } from '@work4all/models/lib/Enums/EMode.enum';

import { useLookUpContext } from '../../../../../../components/data-tables/contexts/LookUpContext';
import { useLookups } from '../../../../../../hooks/use-lookups';

import { LookUpPreview } from './LookUpPreview';

type LookUpPreviewContainerProps = EntityPreviewContainerProps;

export const lookUpPreviewFields: LookUp<EMode.query> = {
  id: null,
  name: null,
  lookupType: null,
  color: null,
  value: null,
  valueDouble: null,
  textValue: null,
  showAs: null,
  standard: null,
  symbol: null,
  groupView: null,
  objKind: null,
  closedStatus: null,
  hexColorPair: null,
  aboVertragAliasKopftext: null,
  aboVertragAliasNotiz: null,
  isVacationKindForShortTimeWork: null,
  userId: null,
  lookUpId: null,
  insertTime: null,
  updateTime: null,
};

export const LookUpPreviewContainer = (props: LookUpPreviewContainerProps) => {
  const {
    ids,
    onCloseClick,
    onEditClicked,
    onShareClicked,
    convertProps,
    onVisibilityToggle,
  } = props;

  const { lookupType } = useLookUpContext();
  const lookUpId = ids[0];

  const { data: lookUps } = useLookups({
    type: lookupType,
    ids: lookUpId ? [Number(lookUpId)] : undefined,
  });

  if (!lookUps?.length) {
    return null;
  }

  return (
    <LookUpPreview
      onCloseClick={onCloseClick}
      onEditClicked={onEditClicked}
      lookUps={lookUps}
      onShareClicked={onShareClicked}
      convertProps={convertProps}
      onVisibilityToggle={onVisibilityToggle}
    />
  );
};
